import { render, staticRenderFns } from "./SummaryData.vue?vue&type=template&id=16721f84&scoped=true&"
import script from "./SummaryData.vue?vue&type=script&lang=js&"
export * from "./SummaryData.vue?vue&type=script&lang=js&"
import style0 from "./SummaryData.vue?vue&type=style&index=0&id=16721f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16721f84",
  null
  
)

export default component.exports